import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function AnchorCaseStudy() {
  return (
    <section
      className="px-6 md:px-12 lg:px-20 py-14 md:py-20"
      style={{ background: "#070A0D", color: "#F5F7FA" }}
      data-testid="anchor-case-study"
    >
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        {/* Image */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.2, 0.7, 0.2, 1] }}
          className="lg:col-span-6 relative"
        >
          <div
            className="relative overflow-hidden rounded-xl"
            style={{
              border: "1px solid rgba(255,255,255,0.10)",
              aspectRatio: "16 / 10",
            }}
          >
            <img
              src="/mockups/06_resorts_golf_estates_hero.webp"
              alt="Kruger Park Lodge — flagship golf estate installation"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div
              className="absolute top-4 left-4 px-3 py-2 font-mono uppercase backdrop-blur-md"
              style={{ background: "rgba(7,10,13,0.75)", border: "1px solid rgba(255,255,255,0.10)", borderRadius: "6px", fontSize: "0.62rem", letterSpacing: "0.16em", color: "#F5F7FA" }}
            >
              Portfolio · Case study
            </div>
          </div>
        </motion.div>

        {/* Content */}
        <div className="lg:col-span-6">
          <div className="font-mono uppercase mb-5" style={{ fontSize: "0.62rem", letterSpacing: "0.26em", color: "#1FB6C1" }}>
            Flagship install · Kruger Park Lodge
          </div>
          <h2
            className="font-display"
            style={{ fontSize: "clamp(2rem, 4.5vw, 3.4rem)", lineHeight: 1.06, letterSpacing: "-0.02em", fontWeight: 700, color: "#F5F7FA" }}
          >
            Raw canal water,<br />
            <span style={{ color: "#1FB6C1" }}>delivered safe to every outlet.</span>
          </h2>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-6 mt-8 mb-8">
            {[
              ["~8M L", "PURIFIED · MONTHLY"],
              ["Canal", "RAW SOURCE"],
              ["Flagship", "GOLF ESTATE"],
            ].map(([n, l]) => (
              <div key={l}>
                <div className="font-display" style={{ fontSize: "clamp(1.5rem, 2.6vw, 2.1rem)", fontWeight: 700, color: "#F5F7FA", letterSpacing: "-0.02em", lineHeight: 1 }}>
                  {n}
                </div>
                <div className="font-mono uppercase mt-2" style={{ fontSize: "0.58rem", letterSpacing: "0.18em", color: "#9AA7B4" }}>
                  {l}
                </div>
              </div>
            ))}
          </div>

          <p className="font-light leading-relaxed mb-8" style={{ fontSize: "1rem", color: "#9AA7B4" }}>
            A flagship golf estate inside the Kruger Park footprint. HidroVerse takes raw canal water —
            variable turbidity, seasonal load — and delivers SANS 241 potable water at every outlet across
            the site. One project with continuous support and management has led to further expansion
            phases for this customer, and multiple additional installations have followed off this reference.
          </p>

          <blockquote
            className="pl-5 mb-10"
            style={{ borderLeft: "2px solid #1FB6C1" }}
          >
            <p className="font-display italic leading-relaxed" style={{ fontSize: "1.02rem", color: "#F5F7FA", fontWeight: 300 }}>
              "Joining forces with HidroVerse on our water purification solution has proven to be our greatest
              investment, yielding exceptional returns. Their comprehensive approach — from installation to
              maintenance — has not only ensured seamless operations and great-tasting water to all our residents
              and guests, but added huge value to our offering at Kruger Park Lodge."
            </p>
            <div className="mt-5 font-mono uppercase" style={{ fontSize: "0.62rem", letterSpacing: "0.18em", color: "#9AA7B4" }}>
              André Eden · General Manager, Kruger Park Lodge
            </div>
          </blockquote>

          <Link
            to="/projects"
            className="inline-flex items-center gap-2 font-mono uppercase"
            style={{ fontSize: "0.7rem", letterSpacing: "0.22em", color: "#1FB6C1" }}
            data-testid="anchor-case-study-cta"
          >
            See the full portfolio <span aria-hidden>→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
